import { useContext } from 'react'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'
import configurationServices from '@/configuration/services/services'

import AccountTier from './AccountTier/AccountTier'
import BillingConfigurationSkeleton from './BillingConfigurationSkeleton/BillingConfigurationSkeleton'
import BillingInfo from './BillingInfo/BillingInfo'
import useBillingConfiguration from './hooks/useBillingConfiguration/useBillingConfiguration'
import ReveniSubsidiary from './ReveniSubsidiary/ReveniSubsidiary'
import * as Styles from './styles'

const BillingConfiguration = () => {
  const { info } = useContext(AppContext)
  const { setToastInfo } = useContext(ToastContext)
  const allowsDirectDebit = info?.billing_data?.reveni_subsidiaries?.length > 0

  const {
    fetchData: createPaymentMethod,
    data: paymentMethodCreated,
    loading: creatingPaymentMethod,
    setData: setPaymentMethodCreated,
  } = useFetch(configurationServices.createBankAccount, {
    doInitialRequest: false,
  })

  const { fetchData: changeSubscriptionPlan } = useFetch(configurationServices.changeSubscriptionPlan, {
    doInitialRequest: false,
  })

  const { fetchBankAccounts, bankAccounts, gettingBankAccounts, gettingBillingPreferences } = useBillingConfiguration()

  const onActiveSubscription = async subscriptionPlan => {
    try {
      await changeSubscriptionPlan({ subscriptionPlan })
    } catch (err) {
      setToastInfo({ show: true, message: err.errorMessage, type: 'error' })
    }
  }

  if (gettingBankAccounts || gettingBillingPreferences) {
    return <BillingConfigurationSkeleton />
  }

  return (
    <Styles.Container>
      <Styles.BillingInfoContainer>
        <AccountTier subscriptionPlan={info?.subscription_plan} onActiveSubscription={onActiveSubscription} />
        <BillingInfo billingInfo={{ ...info?.billing_data, email: info?.email }} />
      </Styles.BillingInfoContainer>
      {allowsDirectDebit && (
        <>
          <Divider />
          {info?.billing_data?.reveni_subsidiaries.map((subsidiary, index) => (
            <ReveniSubsidiary
              key={index}
              subsidiary={subsidiary}
              bankAccounts={bankAccounts}
              createPaymentMethod={createPaymentMethod}
              creatingPaymentMethod={creatingPaymentMethod}
              fetchBankAccounts={fetchBankAccounts}
              paymentMethodCreated={paymentMethodCreated}
              setPaymentMethodCreated={setPaymentMethodCreated}
            />
          ))}
        </>
      )}
    </Styles.Container>
  )
}

export default BillingConfiguration
